import { UsaBanner as UsaBannerComponent } from '@cmsgov/design-system';
import './UsaBanner.css';

interface UsaBannerProps {
  className?: string;
  id: string;
  /**
   * Test ID for automated testing
   */
  'data-testid'?: string;
}

export default function UsaBanner({ className, id, 'data-testid': dataTestId }: UsaBannerProps) {
  return (
    <UsaBannerComponent
      className={className}
      data-testid={dataTestId ?? 'usa-banner'}
      id={id}
    />
  );
}
